<template>
    <div id="wrapper" >
      <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.history.myorders.admin.label.title')}}</h4>

                            </div>
                        </div>
                    </div>

                     <div class="row">
                       
                       <div class="col-lg-12">
                        <div class="card-box">
                            <h4 class="header-title mb-4">
                                <h4 class="page-title">
                                    {{$t('string.msg.orders.admin.label.title')}}
                                </h4>
                            </h4>
                     
                            <div>
                                <b-tabs>

                                    <b-tab active :class="{ 'hidden': !hasType('FLEET_DRIVER') }">
                                    <template v-slot:title>
                                        <strong>{{$t('string.msg.product.parts.label.title')}}</strong>
                                    </template>
                                    <ListOrdersParts :company="company"/>
                                    </b-tab>

                                    <b-tab v-bind:class="{ 'hidden': !hasType('FLEET_DRIVER') }">
                                    <template v-slot:title>
                                         <strong>{{$t('string.msg.dashboard.services.tab')}}</strong>
                                    </template>
                                    <ListOrdersServices :company="company"/>
                                    </b-tab>
                                    
                                    <b-tab v-bind:class="{ 'hidden': !hasType('FLEET_DRIVER') }">
                                    <template v-slot:title>
                                        <strong>{{$t('string.msg.dashboard.certifie.tab')}}</strong>
                                    </template>
                                    <ListOrdersCertifie :company="company"/>
                                    </b-tab>

                                </b-tabs>
                            </div>
                            
                        </div>
                        <!-- end card-box-->
                      </div>
                      <!-- end col -->
                     </div>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <ModalTermParts  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermCertifies  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermServices  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTerm v-on:confirmation-return="acceptedTermGeneral"/>
    </div>
</template>

<script>

import Controller from './CrtMyOrders';
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';

import ModalTerm from '../../Modal/Term/ModalTerm';
import ModalTermParts from '../../Modal/Term/ModalTermParts';
import ModalTermServices from '../../Modal/Term/ModalTermService';
import ModalTermCertifies from '../../Modal/Term/ModalTermCertifie';

import ListOrdersParts from './Parts/ListOrdersParts';
import ListOrdersServices from './Services/ListOrdersServices';
import ListOrdersCertifie from './Certifies/ListOrdersCertifie';

import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
Vue.use(BootstrapVue)

export default {
    name: 'Dashboard',
    components: {
    Spinner,
    Toast,
    ListOrdersParts,
    ListOrdersServices,
    ListOrdersCertifie,
    ModalTerm,
    ModalTermParts,
    ModalTermServices,
    ModalTermCertifies
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            orders: [],
            company:null,
            checkTerm: null,
            dataCompany:{},
            data: {
            },
            user: {
                serviceTypes: []
            }
        }
    },
    methods: Controller.methods,
    created() {
    },
    mounted() {
        Controller.init(this);
    }
    }
    </script>

    <style>
    </style>
